import { useGenErrorMsgBanners } from "@/utils/useGenErrorMsgBanners";
import axios from "axios";
import { useBannerContext } from "oolib";
import { useMutation, useQuery, useQueryClient } from "react-query";

export const useGetAllReports = (options = {}) => {
  const { enabled } = options;
  return useQuery(
    ["allReports"],
    () =>
      axios.get(`/api/reports/getAllReports`).then((res) => res.data),
    {
      enabled,
    }
  );
};

export const useViewReport = (options = {}) => {
  const { reportId, enabled } = options;
  return useQuery(
    ["reports", reportId],
    () =>
      axios.get(`/api/reports/viewReport/${reportId}`).then((res) => res.data),
    {
      enabled,
    }
  );
};

export const useCreateReport = () => {
  const { genErrorMsgBanners } = useGenErrorMsgBanners();
  return useMutation(
    ({ type, title, subtitle }) =>
      axios.post(
        `/api/reports/createReport/${type}`,
        {
          title, subtitle
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      ),
    {
      onError: (err) => {
        genErrorMsgBanners({ err });
      },
    }
  );
};

export const useDeleteReport = () => {
  const { SET_INFO_BANNER } = useBannerContext();
  const queryClient = useQueryClient();
  const { genErrorMsgBanners } = useGenErrorMsgBanners();
  return useMutation(
    ({ reportId, title }) =>
      axios.delete(`/api/reports/deleteReport/${reportId}`),

    {
      onSuccess: (res, mutationArgs) => {
        SET_INFO_BANNER({
          color: "green",
          msg: `Report: ${mutationArgs.title} deleted successfully!`,
          timeOut: 3000,
        });
        queryClient.invalidateQueries(["reports", mutationArgs.reportId]);
      },

      onError: (err) => {
        genErrorMsgBanners({ err });
      },
    }
  );
};

export const usePublishReport = () => {
  const queryClient = useQueryClient();
  const { SET_INFO_BANNER } = useBannerContext();
  const { genErrorMsgBanners } = useGenErrorMsgBanners();
  return useMutation(
    ({ reportId, config, title, subtitle }) =>
      axios.patch(
        `/api/reports/publishReport/${reportId}`,
        {
          config,
          title,
          subtitle
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      ),
    {
      onSuccess: (res, mutationArgs) => {
        queryClient.invalidateQueries(["reports", mutationArgs.reportId]);
        SET_INFO_BANNER({
          color: "green",
          msg: `Report: ${res.data.title} published successfully!`,
          timeOut: 3000,
        });
      },
      onError: (err) => {
        genErrorMsgBanners({ err });
      },
    }
  );
};
